export const CARRY_ON_LABELS = {
  CARRY_ON_10KG: 'Carry on 10kg',
  CARRY_ON_PLUS_5KG: 'Carry on +5kg',
  CARRY_ON: 'Carry on',
};